var __MODULE_HASH__ = "034e5c732f1beb3492ad329ec6109eaf";
export const screens = {
	// => @media (min-width: 375px) { ... }
	sm: 375,
	// => @media (min-width: 767px) { ... }
	md: 767,
	// => @media (min-width: 1024px) { ... }
	lg: 1024,
	// => @media (min-width: 1024px) { ... }
	xl: 1280,
};
